// import i18n from '../../../components/i18n'
import i18n from '../../../lang/index'
console.log(i18n,"i18n")
import {
  getMyPaymentList,
  getGoodsList,
  shopItemOrderDetailListByCode,
  getArchiveList,
  shopStatislistByCode,
  listByCode,
  listByTime,
  generalSaleMachinehour
} from "@/api/tables"
export const columns_ = [
    // 我的付款
    {
        code: 'myPayment', // 报表标识
        columObj: {
            // 选择框
            selection: false,
            // 选择框根据条件是否可选
            selectable: (row, index) => {
                return true;
            },
            lazy: "true",
            loading: false,
            keyField: 'itemName',
            selectFiled: 'itemName',
            modelFiled: 'itemName', // 关联全局变量字段
            placeholder: i18n.t('applyCommonTable.searchCom'),
            listApi: getMyPaymentList, // 列表 api
            searchApi: getGoodsList, // 自动补全搜索框 api
            columnData: [
                {
                    text: true,
                    prop: "index",
                    label: i18n.t('archiveManagerMachive.serialNum'),
                    width: "50",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "itemName",
                    // label: i18n.t('applyCommonTable.commodityName'),
                    label:i18n.t('goodsEdit.language'),
                    width: "",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "itemNumber",
                    label: i18n.t('applyChild.number'),
                    width: "",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "itemSpecification",
                    label: i18n.t('archiveManagerMachive.type'),
                    width: "",
                    align: "center",
                  },
                  {
                    ownDefined: true, // 自定定义列内容
                    ownDefinedReturn: (row, $index) => {
                      return row.unit + row.price
                    },
                    prop: "price",
                    label: i18n.t('archiveManagerMachive.amount'),
                    width: "",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "createTime",
                    label: i18n.t('archiveManagerMachive.date'),
                    width: "",
                    align: "center",
                },
            ],
        },
    },
    // 总代采购
    {
      code: 'generalOrder', // 报表标识
      columObj: {
          // 选择框
          selection: false,
          // 选择框根据条件是否可选
          selectable: (row, index) => {
              return true;
          },
          lazy: "true",
          loading: false,
          keyField: 'itemName',
          selectFiled: 'itemName',
          modelFiled: 'itemName', // 关联全局变量字段
          placeholder: i18n.t('applyCommonTable.searchCom'),
          listApi: getMyPaymentList, // 列表 api
          searchApi: getGoodsList, // 自动补全搜索框 api
          columnData: [
              {
                  text: true,
                  prop: "index",
                  label: i18n.t('archiveManagerMachive.serialNum'),
                  width: "50",
                  align: "center",
                },
                {
                  text: true,
                  prop: "itemName",
                  label: i18n.t('applyCommonTable.commodityName'),
                  width: "",
                  align: "center",
                },
                {
                  text: true,
                  prop: "itemNumber",
                  label: i18n.t('applyChild.number'),
                  width: "",
                  align: "center",
                },
                {
                  ownDefined: true,
                  ownDefinedReturn: (row, $index) => {
                        let typeName = ['',i18n.t('goodsDetail.product'),i18n.t('goodsDetail.part'),i18n.t('reportfilter.accessories')]
                        return typeName[row.type]

                  },
                  prop: "itemSpecification",
                  label: i18n.t('logsIndex.type'),
                  width: "",
                  align: "center",
                },
                {
                  ownDefined: true, // 自定定义列内容
                  ownDefinedReturn: (row, $index) => {
                    return row.unit + row.price
                  },
                  prop: "price",
                  label: i18n.t('archiveManagerMachive.amount'),
                  width: "",
                  align: "center",
                },
                {
                  text: true,
                  prop: "createTime",
                  label: i18n.t('archiveManagerMachive.date'),
                  width: "",
                  align: "center",
              },
          ],
      },
  },
    // 店铺采购
    {
        code: 'shopOrder',
        columObj: {
            // 选择框
            selection: false,
            // 选择框根据条件是否可选
            selectable: (row, index) => {
                return true;
            },
            lazy: "true",
            loading: false,
            keyField: 'archiveName',
            selectFiled: 'shopName',
            modelFiled: 'shopName',
            placeholder: i18n.t('archiveManagerMachive.searchStore'),
            listApi: shopItemOrderDetailListByCode,
            searchParams: "general,area,shop",
            searchApi: getArchiveList,
            columnData: [
                {
                    text: true,
                    prop: "index",
                    label: i18n.t('archiveManagerMachive.serialNum'),
                    width: "50",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "shopName",
                    label: i18n.t('serviceAlarmOrder.storeName'),
                    width: "",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "itemName",
                    label: i18n.t('applyCommonTable.commodityName'),
                    width: "",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "itemNumber",
                    label: i18n.t('applyChild.number'),
                    width: "",
                    align: "center",
                  },
                  {
                    ownDefined: true,
                    ownDefinedReturn: (row, $index) => {
                          let typeName = ['',i18n.t('goodsDetail.product'),i18n.t('goodsDetail.part'),i18n.t('reportfilter.accessories')]
                           return typeName[row.type]

                    },
                    prop: "itemSpecification",
                    label: i18n.t('archiveManagerMachive.type'),
                    width: "",
                    align: "center",
                  },
                  {
                    ownDefined: true,
                    ownDefinedReturn: (row, $index) => {
                      return row.unit + row.price
                    },
                    prop: "price",
                    label: i18n.t('archiveManagerMachive.amount'),
                    width: "",
                    align: "center",
                  },
                  {
                    text: true,
                    prop: "createTime",
                    label: i18n.t('archiveManagerMachive.date'),
                    width: "",
                    align: "center",
                },
            ],
        },
    },
    // 装机总报表
    {
      code: 'applyDevice',
      columObj: {
          // 选择框
          selection: false,
          // 选择框根据条件是否可选
          selectable: (row, index) => {
              return true;
          },
          lazy: "true",
          loading: false,
          keyField: 'archiveName',
          selectFiled: 'shopName',
          modelFiled: 'shopName',
          placeholder: i18n.t('archiveManagerMachive.searchStore'),
          listApi: shopStatislistByCode,
          searchParams: "area,shop",
          searchApi: getArchiveList,
          columnData: [
              {
                  text: true,
                  prop: "index",
                  label: i18n.t('archiveManagerMachive.serialNum'),
                  width: "50",
                  align: "center",
                },
                {
                  text: true,
                  prop: "shopName",
                  label: i18n.t('serviceAlarmOrder.storeName'),
                  width: "",
                  align: "center",
                },
                {
                  text: true,
                  prop: "deviceNumber",
                  label: i18n.t('applyChild.number'),
                  width: "",
                  align: "center",
                },
                {
                  text: true,
                  prop: "createTime",
                  label: i18n.t('archiveManagerMachive.date'),
                  width: "",
                  align: "center",
              },
          ],
      },
    },
    // 租赁保证金报表
    {
      code: 'leaseDeposit',
      columObj: {
          // 选择框
          selection: false,
          // 选择框根据条件是否可选
          selectable: (row, index) => {
              return true;
          },
          lazy: "true",
          loading: false,
          keyField: 'archiveName',
          selectFiled: 'shopName',
          modelFiled: 'shopName',
          placeholder: i18n.t('archiveManagerMachive.searchStore'),
          listApi: listByCode,
          searchParams: "area,shop",
          searchApi: getArchiveList,
          columnData: [
              {
                  text: true,
                  prop: "index",
                  label: i18n.t('archiveManagerMachive.serialNum'),
                  width: "50",
                  align: "center",
                },
                {
                  text: true,
                  prop: "shopName",
                  label: i18n.t('serviceAlarmOrder.storeName'),
                  width: "",
                  align: "center",
            },
              {
                text: true,
                prop: "typeName",
                label:'类型',
                width: "",
                align: "center",
              },
                {
                  ownDefined: true,
                  ownDefinedReturn: (row, $index) => {
                    return row.unit + row.leaseDeposit
                  },
                  prop: "leaseDeposit",
                  label: i18n.t('archiveManagerMachive.amount'),
                  width: "",
                  align: "center",
                },
                {
                  text: true,
                  prop: "createTime",
                  label: i18n.t('archiveManagerMachive.date'),
                  width: "",
                  align: "center",
              },
          ],
      },
    },
    // 总收购机时款报表
    {
      code: 'generalSaleMachinehourMoney',
      columObj: {
          // 选择框
          selection: false,
          // 选择框根据条件是否可选
          selectable: (row, index) => {
              return true;
          },
          lazy: "true",
          loading: false,
          keyField: 'archiveName',
          selectFiled: 'shopName',
          modelFiled: 'shopName',
          placeholder: i18n.t('archiveManagerMachive.searchStore'),
          listApi: listByTime,
          searchParams: "area,shop",
          searchApi: getArchiveList,
          columnData: [
              {
                  text: true,
                  prop: "index",
                  label: i18n.t('archiveManagerMachive.serialNum'),
                  width: "50",
                  align: "center",
                },
                {
                  text: true,
                  prop: "shopName",
                  label: i18n.t('serviceAlarmOrder.storeName'),
                  width: "",
                  align: "center",
                },
                {
                  ownDefined: true,
                  ownDefinedReturn: (row, $index) => {
                    return '$' + row.payMoney
                  },
                  prop: "payMoney",
                  label: i18n.t('archiveManagerMachive.amount'),
                  width: "",
                  align: "center",
                },
                {
                  ownDefined: true,
                  prop: "machineHourHour",
                  label: i18n.t('archiveManagerMachive.duration'),
                  width: "",
                  align: "center",
                  ownDefinedReturn: (row, $index) => {
                    return row.machineHourHour
                  }
                },
                {
                  text: true,
                  prop: "buyAnnotation",
                  label: i18n.t('machineHourAudit.machineHourDetails'),
                  width: "",
                  align: "center",
                },
                {
                  text: true,
                  prop: "createTime",
                  label: i18n.t('archiveManagerMachive.date'),
                  width: "",
                  align: "center",
              },
          ],
      },
    },
    // 总售出机时报表
    {
      code: 'generalSaleMachinehour',
      columObj: {
          // 选择框
          selection: false,
          // 选择框根据条件是否可选
          selectable: (row, index) => {
              return true;
          },
          lazy: "true",
          loading: false,
          keyField: 'archiveName',
          selectFiled: 'shopName',
          modelFiled: 'shopName',
          placeholder: i18n.t('archiveManagerMachive.searchStore'),
          listApi: generalSaleMachinehour,
          searchParams: "area,shop",
          searchApi: getArchiveList,
          columnData: [
              {
                  text: true,
                  prop: "index",
                  label: i18n.t('archiveManagerMachive.serialNum'),
                  width: "50",
                  align: "center",
                },
                {
                  text: true,
                  prop: "shopName",
                  label: i18n.t('serviceAlarmOrder.storeName'),
                  width: "",
                  align: "center",
                },
                {
                  ownDefined: true,
                  ownDefinedReturn: (row, $index) => {
                    return row.unit + row.price
                  },
                  prop: "price",
                  label: i18n.t('archiveManagerMachive.amount'),
                  width: "",
                  align: "center",
                },
                {
                  ownDefined: true,
                  ownDefinedReturn: (row, $index) => {
                    return row.machineHourHour + ' h'
                  },
                  prop: "machineHourHour",
                  label: i18n.t('archiveManagerMachive.duration'),
                  width: "",
                  align: "center",
                },
                {
                  text: true,
                  prop: "createTime",
                  label: i18n.t('archiveManagerMachive.date'),
                  width: "",
                  align: "center",
              },
              // {
              //   isOperation: true,
              //   label: "操作",
              //   width: "180",
              //   align: "center",
              //   sortable: false,
              //   operation: [{
              //     type: "text",
              //     label: "编辑",
              //     action: 'edit',
              //     icon: "",
              //     color: 'red',
              //     buttonClick: window.rowOperation(),
              //     isShow: (row, $index) => {
              //       return true;
              //     }
              //   }]
              // },
          ],
      },
    }
];
